import React from 'react';

const SendNotifications = () => {
  return <div className="text-2xl font-sora text-driveeasy-blue">SendNotifications Page</div>;
};

export default SendNotifications;